import api from './api';

// Banco de preguntas
const getQuestions = async (classroomId, questionTypeId) => {
    try {
        const query = questionTypeId ? `?questionTypeId=${questionTypeId}` : '';
        const response = await api.get(`/classroom-exam/question/classroom/${classroomId}${query}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getQuestion = async (questionId) => {
    try {
        const response = await api.get(`/classroom-exam/question/${questionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createQuestion = async (questionData) => {
    try {
        const response = await api.post(`/classroom-exam/question`, questionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateQuestion = async (questionData) => {
    try {
        const response = await api.put(`/classroom-exam/question`, questionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteQuestion = async (questionId) => {
    try {
        const response = await api.delete(`/classroom-exam/question/${questionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Exámenes
const getExams = async (classroomId) => {
    try {
        const response = await api.get(`/classroom-exam/classroom/${classroomId}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getExam = async (examId) => {
    try {
        const response = await api.get(`/classroom-exam/${examId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createExam = async (examData) => {
    try {
        const response = await api.post(`/classroom-exam`, examData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateExam = async (examData) => {
    try {
        const response = await api.put(`/classroom-exam`, examData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteExam = async (examId) => {
    try {
        const response = await api.delete(`/classroom-exam/${examId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Preguntas del examen / ponderación. forStudent=true oculta isCorrect.
const getExamQuestions = async (examId, forStudent = false) => {
    try {
        const response = await api.get(`/classroom-exam/${examId}/questions?forStudent=${forStudent}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getWeightStatus = async (examId) => {
    try {
        const response = await api.get(`/classroom-exam/${examId}/weight-status`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const addExamQuestion = async (examQuestionData) => {
    try {
        const response = await api.post(`/classroom-exam/exam-question`, examQuestionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateExamQuestionWeight = async (examQuestionId, weightPercentage, modificationUser) => {
    try {
        const response = await api.put(`/classroom-exam/exam-question/${examQuestionId}/weight`, { weightPercentage, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const removeExamQuestion = async (examQuestionId) => {
    try {
        const response = await api.delete(`/classroom-exam/exam-question/${examQuestionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Intentos
const startAttempt = async (examId, studentId, createdUser) => {
    try {
        const response = await api.post(`/classroom-exam/${examId}/attempt`, { studentId, createdUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const submitAttempt = async (attemptId, answers, modificationUser) => {
    try {
        const response = await api.post(`/classroom-exam/attempt/${attemptId}/submit`, { answers, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getAttempt = async (attemptId) => {
    try {
        const response = await api.get(`/classroom-exam/attempt/${attemptId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getAttemptsForStudent = async (examId, studentId) => {
    try {
        const response = await api.get(`/classroom-exam/${examId}/student/${studentId}/attempts`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

// Calificación de respuestas abiertas / de archivo
const gradeAnswer = async (answerId, pointsAwarded, feedbackHtml, modificationUser) => {
    try {
        const response = await api.put(`/classroom-exam/answer/${answerId}/grade`, { pointsAwarded, feedbackHtml, modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Requisito 6: listado de estudiantes matriculados con su último intento
const getRoster = async (examId) => {
    try {
        const response = await api.get(`/classroom-exam/${examId}/roster`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

export default {
    getQuestions,
    getQuestion,
    createQuestion,
    updateQuestion,
    deleteQuestion,
    getExams,
    getExam,
    createExam,
    updateExam,
    deleteExam,
    getExamQuestions,
    getWeightStatus,
    addExamQuestion,
    updateExamQuestionWeight,
    removeExamQuestion,
    startAttempt,
    submitAttempt,
    getAttempt,
    getAttemptsForStudent,
    gradeAnswer,
    getRoster
};
